import { Divider, ListItemButton, Typography } from '@mui/material'
import { IconButton } from '@mui/material'
import { Grid2 } from '@mui/material'
import { Container } from '@mui/material'
import { Box } from '@mui/material'
import { Link, useNavigate } from 'react-router'
import { Iconify } from 'src/components/iconify'
import { useStore } from 'src/store/StoreContext'

export const getIcon = (name: string, size = 22) => (
    <Iconify icon={name} width={size} height={size} />
);


const footerContent = {
    heading: 'About PTH',
    about: 'Get affordable tele healthcare from the comfort of your homes, with quick access to qualified, AHPRA registered, Australian doctors & health practitioners, 24/7, 365 days a year.',
    contactHeading: 'Get in touch',
    mail: 'needhelp@company.com',
    fax: '+123 456 7890',
    street: '52 Ridge Road,',
    city: 'Howard',
    zip: '4659',
    country: 'Australia'
}

export const serviceMenu1 = [
    {
        name: "Home",
        url: '/',
    },
    // {
    //     name: "Customer Service",
    //     url: 'Aboutus',
    // },
    // {
    //     name: "Contact Us",
    //     url: '/',
    // },
    {
        name: "For Doctors",
        url: '/doc-intro',
    },
    {
        name: "For Patients",
        url: 'register/patient',
    },
    {
        name: "Contact Us",
        url: 'Contact',
    },
    // {
    //     name: "In the News",
    //     url: '/',
    // }
];

export const socialLinks = [
    {
        name: 'facebook',
        url: '/',
        icon: getIcon('ri:facebook-fill')
    },
    {
        name: 'linkedin',
        url: '/',
        icon: getIcon('ri:linkedin-fill')
    },
    {
        name: 'twitter',
        url: '/',
        icon: getIcon('proicons:x-twitter'),
    },
    {
        name: 'pinterest',
        url: '/',
        icon: getIcon('fe:pinterest')
    }

]

const Footer = () => {
    const store = useStore();
    const navigate = useNavigate();
    return (
        <Box bgcolor={'grey.600'} color={'white'} >
            <Divider />
            <Container maxWidth={'lg'}>
                <Grid2 spacing={3} container p={2}>
                    <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography mb={2} color={'white'} variant='h5'>
                            {footerContent.heading}
                        </Typography>
                        <Typography lineHeight={2} color={'white'} variant='body2'>
                            {footerContent.about}
                        </Typography>
                        <Box py={1} display={'flex'} gap={3}>
                            {
                                socialLinks.map((link, idx) => <IconButton key={idx} color='success'>
                                    {link.icon}
                                </IconButton>)
                            }
                        </Box>
                    </Grid2>
                    <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                        <Box textAlign={'start'} display={'grid'}>
                            {serviceMenu1.map((menu, idx) => <ListItemButton key={idx} sx={{
                                '&:hover': {
                                    backgroundColor: 'inherit',
                                    boxShadow: 'none',
                                    cursor: 'pointer',
                                    color: 'success.main',
                                },
                                '&:focus': {
                                    outline: 'none',
                                    boxShadow: 'none',
                                },
                            }}   onClick={() => {
                navigate(menu.url, { replace: false });
                window.location.reload(); 
            }}
        >
            {menu.name}</ListItemButton>)}
                        </Box>
                    </Grid2>
                    <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                        <Box textAlign={'start'} display={'grid'}>
                            {store?.home.services
                                ?.filter(
                                    (service) =>
                                        Array.isArray(service.subService) &&
                                        service.subService.length > 0
                                )
                                .map((menu, idx) => (
                                    <ListItemButton
                                        key={idx}
                                        sx={{
                                            '&:hover': {
                                                backgroundColor: 'inherit',
                                                boxShadow: 'none',
                                                cursor: 'pointer',
                                                color: 'success.main',
                                            },
                                            '&:focus': {
                                                outline: 'none',
                                                boxShadow: 'none',
                                            },
                                        }}
                                         onClick={() => {
                    navigate(`/service/${menu.id}`, { replace: false }); 
                    window.location.reload(); // 🔥 force refresh
                }}
            >
                {menu.title}
                                    </ListItemButton>
                                ))}
                        </Box>
                    </Grid2>

                    <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography mb={2} color={'white'} variant='h5'>
                            {footerContent.contactHeading}
                        </Typography>
                        <Typography color={'white'} variant='body1'>
                            Mail: <Typography component={'span'} color={'white'} variant='h6'>{footerContent.mail}</Typography>
                        </Typography>
                        <Typography my={1} color={'white'} variant='body1'>
                            Fax: <Typography component={'span'} color={'white'} variant='body1'>{footerContent.fax}</Typography>
                        </Typography>
                        <Typography my={1} color={'white'} variant='body1'>
                            Street: <Typography component={'span'} color={'white'} variant='body1'>{footerContent.street}</Typography>
                        </Typography>
                        <Typography my={1} color={'white'} variant='body1'>
                            City: <Typography component={'span'} color={'white'} variant='body1'>{footerContent.city}</Typography>
                        </Typography>
                        <Typography my={1} color={'white'} variant='body1'>
                            Country: <Typography component={'span'} color={'white'} variant='body1'>{footerContent.country}</Typography>
                        </Typography>
                        <Typography my={1} color={'white'} variant='body1'>
                            Zip code: <Typography component={'span'} color={'white'} variant='body1'>{footerContent.zip}</Typography>
                        </Typography>
                    </Grid2>
                </Grid2>

                <Divider />
                <Box
                    p={2}
                    display="flex"
                    justifyContent="space-between"
                >
                    <Typography variant="button">
                        Copyright © {new Date().getFullYear()} PrimeHealth. All rights reserved
                    </Typography>
                </Box>
            </Container>
        </Box>
    )
}

export default Footer